import React from 'react'
import styled from 'styled-components'
import { device } from '../../../utils/helpers'
import CaretIcon from '../../UI/Icons/CaretIcon'

const ComponentWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  font-size: 14px;
  font-family: 'BarlowExtraBold';
  text-transform: uppercase;
  color: #999;
  ${''/* padding-left: 85px; */}
  padding-left: 4.427083333333334vw;

  @media ${device.tablet} {
    font-size: 0.9375vw;
    line-height: 1.5625vw;
  }
`

const ComponentSubWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  cursor: pointer;
`

const ComponentDetail = styled.div`
  font-size: 12px;
  font-family: 'BarlowSemiBold';
  padding-left: 10px;

  @media ${device.tablet} {
    font-size: 0.7291666666666667vw;
  }
`

const Caret = styled(CaretIcon)`
  width: 7px;

  @media ${device.tablet} {
    width: 0.36458333333333337vw;
  }
`

class Component extends React.Component {
  state = {
    showDetail: false
  }

  toggleDetails (e) {
    e.stopPropagation()
    this.setState({ showDetail: !this.state.showDetail })
  }

  render () {
    const { details, name, price } = this.props
    const { showDetail } = this.state
    return (
      <ComponentWrapper>
        {/* If there are no details for a component selected,
          * then show a bullet else show expandable div with caret symbol
        */}
        {!details
          ? <React.Fragment>
            <div>&bull; {name}</div>
            <div>+ {price} €</div>
          </React.Fragment>
          : <div style={{ width: '100%' }}>
            <ComponentSubWrapper onClick={this.toggleDetails.bind(this)}>
              <div><Caret fill='#999999' transform={showDetail ? 'rotate(90)' : undefined} /> {name}</div>
              <div>+ {price} €</div>
            </ComponentSubWrapper>
            {showDetail && <ComponentDetail>{details.map(detail => detail)}</ComponentDetail>}
          </div>
        }
      </ComponentWrapper>
    )
  }
}

export default Component



// WEBPACK FOOTER //
// ./src/components/Calculator/Sidebar/Component.js